import * as Yup from "yup"
import { AcademicLevel, Campus, Email, FirstName, LastName, MobilePhoneRequired, Consentement } from "services/validation"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    PGE__c: Yup.boolean(),
    BMI__c: Yup.boolean(),
  }).test(
    "at-least-one-program",
    "Veuillez sélectionner au moins un programme.",
    function (lead) {
      const hasAtLeastOne = Boolean(lead?.PGE__c || lead?.BMI__c)
      if (hasAtLeastOne) return true

      return this.createError({
        path: "lead.BMI__c",
        message: "Veuillez sélectionner au moins un programme."
      })
    }
  )
})

export default schema
